import { Folder, Image, LayoutDashboard, Mail, Newspaper, Package, Tag, Users } from "lucide-react";
import AboutPage from "../Pages/AboutPage/AboutPage";
import BrandPage from "../Pages/Brand/BrandPage";
import ContactPage from "../Pages/ContactPage/ContactPage";
import HomePage from "../Pages/Home/HomePage";
import NewsUpdatesDetailPage from "../Pages/NewsUpdatesDetailPage/NewsUpdatesDetailPage";
import NewsUpdatesPage from "../Pages/NewsUpdatesPage/NewsUpdatesPage";
import ProductDetailsPage from "../Pages/ProductDetailsPage/ProductDetailsPage";
import ProductPage from "../Pages/ProductPage/ProductPage";
import AdminDashboard from "../Pages/Admin/AdminDashboard/AdminDashboard";
import AdminMedia from "../Pages/Admin/AdminMedia/AdminMedia";
import AdminNewsUpdates from "../Pages/Admin/AdminNewsUpdates/AdminNewsUpdates";
import AdminContact from "../Pages/Admin/AdminContact/AdminContact";
import AdminProduct from "../Pages/Admin/AdminProduct/AdminProduct";
import AdminBrand from "../Pages/Admin/AdminBrand/AdminBrand";
import AdminCategory from "../Pages/Admin/AdminCategory/AdminCategory";
import AdminUsers from "../Pages/Admin/AdminUsers/AdminUsers";
import AddAdminBrand from "../Pages/Admin/AdminBrand/AddAdminBrand";
import EditAdminBrand from "../Pages/Admin/AdminBrand/EditAdminBrand";
import AddAdminCategory from "../Pages/Admin/AdminCategory/AddAdminCategory";
import EditAdminCategory from "../Pages/Admin/AdminCategory/EditAdminCategory";
import AddAdminNewsUpdates from "../Pages/Admin/AdminNewsUpdates/AddAdminNewsUpdates";
import EditAdminNewsUpdates from "../Pages/Admin/AdminNewsUpdates/EditAdminNewsUpdates";
import AddAdminProduct from "../Pages/Admin/AdminProduct/AddAdminProduct";
import EditAdminProduct from "../Pages/Admin/AdminProduct/EditAdminProduct";

export const routeList = [
  {
    path: "/",
    showMenuBar: true,
    menuLabel: "Home",
    Component: HomePage,
  },
  {
    path: "/about",
    showMenuBar: true,
    menuLabel: "About",
    Component: AboutPage,
  },
  {
    path: "/products",
    showMenuBar: true,
    menuLabel: "Products",
    Component: ProductPage,
  },
  {
    path: "/products/product-details/:id",
    showMenuBar: false,
    menuLabel: "Product Details",
    Component: ProductDetailsPage,
  },
  {
    path: "/news-updates",
    showMenuBar: true,
    menuLabel: "News & Updates",
    Component: NewsUpdatesPage,
  },
  {
    path: "/news-updates-details/:slug",
    showMenuBar: false,
    menuLabel: "News & Updates",
    Component: NewsUpdatesDetailPage,
  },
  {
    path: "/contact",
    showMenuBar: true,
    menuLabel: "Contact",
    Component: ContactPage,
  },
  {
    path: "/top-brand",
    showMenuBar: false,
    menuLabel: "Top Brand",
    Component: BrandPage,
  },

];

export const adminRouteList = [
  {
    path: "dashboard",
    showMenuBar: true,
    menuLabel: "Dashboard",
    icon: <LayoutDashboard size={18} />,
    Component: AdminDashboard,
  },
  {
    path: "media",
    showMenuBar: true,
    menuLabel: "Media",
    icon: <Image size={18} />,
    Component: AdminMedia,
  },
  {
    path: "news-updates",
    showMenuBar: true,
    menuLabel: "News & Update",
    icon: <Newspaper size={18} />,
    Component: AdminNewsUpdates,
  },
  {
    path: "news-updates/add-news-updates",
    showMenuBar: false,
    menuLabel: "Add News & Update",
    icon: <Newspaper size={18} />,
    Component: AddAdminNewsUpdates,
  },
  {
    path: "news-updates/edit-news-updates/:id",
    showMenuBar: false,
    menuLabel: "Edit News & Update",
    icon: <Newspaper size={18} />,
    Component: EditAdminNewsUpdates,
  },
  {
    path: "product",
    showMenuBar: true,
    menuLabel: "Product",
    icon: <Package size={18} />,
    Component: AdminProduct,
  },
  {
    path: "product/add-product",
    showMenuBar: false,
    menuLabel: "Add product",
    icon: <Package size={18} />,
    Component: AddAdminProduct,
  },
  {
    path: "product/edit-product/:id",
    showMenuBar: false,
    menuLabel: "Edit Product",
    icon: <Users size={18} />,
    Component: EditAdminProduct,
  },
  {
    path: "category",
    showMenuBar: true,
    menuLabel: "Category",
    icon: <Folder size={18} />,
    Component: AdminCategory,
  },
  {
    path: "category/add-category",
    showMenuBar: false,
    menuLabel: "Add Category",
    icon: <Users size={18} />,
    Component: AddAdminCategory,
  },
  {
    path: "category/edit-category/:id",
    showMenuBar: false,
    menuLabel: "Edit Category",
    icon: <Users size={18} />,
    Component: EditAdminCategory,
  },
  {
    path: "brand",
    showMenuBar: true,
    menuLabel: "Brand",
    icon: <Tag size={18} />,
    Component: AdminBrand,
  },
  {
    path: "brand/add-brand",
    showMenuBar: false,
    menuLabel: "Add Brand",
    icon: <Users size={18} />,
    Component: AddAdminBrand,
  },
  {
    path: "brand/edit-brand/:id",
    showMenuBar: false,
    menuLabel: "Edit Brand",
    icon: <Users size={18} />,
    Component: EditAdminBrand,
  },
  {
    path: "contact",
    showMenuBar: true,
    menuLabel: "Contact",
    icon: <Mail size={18} />,
    Component: AdminContact,
  },
  {
    path: "users",
    showMenuBar: true,
    menuLabel: "Users",
    icon: <Users size={18} />,
    Component: AdminUsers,
  }
]